import React from 'react'

const FeedbackButtonPanel = (props) => {
  return (
    <div className='feedback-panel'>
      {props.children}
    </div>
  )
}

export default FeedbackButtonPanel
